export const newchargeCheckoutUrl = () =>
  document.querySelector('meta[name="newcharge_checkout_url"]')?.content

export const isNewchargeCheckoutRedirectionActive = () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  return (
    document.querySelector('meta[name="newcharge_checkout_redirection_active"]')?.content === 'true' ||
    urlSearchParams.get('checkout') === 'newcharge'
  )
}

export const buildNewchargeCheckoutLoadedUrl = (url, cartJsData) => {
  let payload = {
    currency: cartJsData.currency,
    original_total_price: cartJsData.original_total_price,
    token: cartJsData.token,
    total_price: cartJsData.total_price,
    items: cartJsData.items.map(item => {
      let properties = {}
      for (let prop in item.properties) {
        if (prop.startsWith('_bundle_part_')) {
          properties[prop] = item.properties[prop]
        }
      }
      return {
        properties: properties,
        quantity: item.quantity,
        variant_id: item.variant_id,
        price: item.price,
        sku: item.sku
      }
    })
  }

  const newchargeCheckoutUrlLoaded = new URL(url)
  newchargeCheckoutUrlLoaded.searchParams.append('short_cart', JSON.stringify(payload))

  return newchargeCheckoutUrlLoaded
}
